import React, { useEffect } from 'react';
import Link from './Link';
import { caseStudies, caseStudyPath } from '../data/caseStudies';

const HOME_PATH = '/';

const CaseStudyPage = ({ caseStudy }) => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = `${caseStudy.title} | Chris Martinez`;
        return () => {
            document.title = previousTitle;
        };
    }, [caseStudy]);

    const index = caseStudies.findIndex((cs) => cs.id === caseStudy.id);
    const next = caseStudies[(index + 1) % caseStudies.length];
    const showNext = next && next.id !== caseStudy.id;

    return (
        <div className="cs-page">
            <Link className="cs-back" href={HOME_PATH}>
                ← Back to portfolio
            </Link>

            <header className="cs-header">
                <div className="cs-kicker">Case Study</div>
                <h1 className="cs-title">{caseStudy.title}</h1>
                <p className="cs-summary">{caseStudy.summary}</p>
                <div className="cs-meta">
                    <span className="cs-meta-role">{caseStudy.role}</span>
                    <span>{caseStudy.period}</span>
                </div>
                <div className="rec-exp-tech-row">
                    {caseStudy.tech.map((t) => (
                        <span key={t} className="rec-exp-tech">{t}</span>
                    ))}
                </div>
                {(caseStudy.liveUrl || caseStudy.github) && (
                    <div className="cs-links">
                        {caseStudy.liveUrl && (
                            <a
                                className="rec-primary-btn"
                                href={caseStudy.liveUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Live site ↗
                            </a>
                        )}
                        {caseStudy.github && (
                            <a
                                className="rec-ghost-btn"
                                href={caseStudy.github}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Code ↗
                            </a>
                        )}
                    </div>
                )}
            </header>

            {caseStudy.sections.map((section) => (
                <section key={section.heading} className="cs-section">
                    <div className="rec-section-head">
                        <h2 className="rec-h2">{section.heading}</h2>
                        <div className="rec-line" />
                    </div>
                    {(section.paragraphs || []).map((text) => (
                        <p key={text} className="cs-para">{text}</p>
                    ))}
                    {section.items && (
                        <ul className="cs-list">
                            {section.items.map((item) => (
                                <li key={item.text} className="cs-item">
                                    {item.label && (
                                        <span className="cs-item-label">{item.label}: </span>
                                    )}
                                    {item.text}
                                </li>
                            ))}
                        </ul>
                    )}
                </section>
            ))}

            <footer className="cs-footer">
                <Link className="cs-back" href={HOME_PATH}>
                    ← Back to portfolio
                </Link>
                {showNext && (
                    <Link className="cs-next" href={caseStudyPath(next.id)}>
                        Next: {next.shortTitle} →
                    </Link>
                )}
            </footer>
        </div>
    );
};

export default CaseStudyPage;
